module.exports = __webpack_public_path__ + "media/images/slider001-036d468954141594942c6395bca51b30.jpg";